import { render, staticRenderFns } from "./AdresboekEdit.vue?vue&type=template&id=f8b3989e&scoped=true"
import script from "./AdresboekEdit.vue?vue&type=script&lang=js"
export * from "./AdresboekEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b3989e",
  null
  
)

export default component.exports